import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create, StoreApi, UseBoundStore } from 'zustand';

import { ConfigState } from 'scbk-services/types/config/config-types';
import _ from 'scbk-services/utils/lodash-extension.ts';

import { Channel } from '../enums/channel';
import { Device } from '../enums/device';
import { Envs } from '../enums/envs';
import { Markets } from '../enums/markets';
import { Systems } from '../enums/systems';

let storeInstance: UseBoundStore<StoreApi<ConfigState>> | null = null;

const createStore = () =>
    create<ConfigState>()((set, get) => ({
        instanceId: Math.random().toString(36).substring(2, 15),
        currentEnv: Envs.MOCK,
        currentMarket: Markets.KR,
        currentDevice: Device.PC,
        currentChannel: Channel.MB,
        currentSystem: Systems.AZURE,
        currentConfig: {
            common: {},
        },

        setMarket: (market: Markets) => set({ currentMarket: market }),

        getMarket: () => get().currentMarket,

        setEnv: (env: Envs) => set({ currentEnv: env }),

        getEnv: () => get().currentEnv,

        /**
         * 현재 디바이스를 설정하는 액션
         *
         * @param device - 설정할 디바이스 타입
         */
        setDevice: (device: Device) => {
            set((state) => {
                if (state.currentDevice !== device) {
                    return { currentDevice: device };
                }
                return state;
            });
        },

        /**
         * 현재 디바이스를 반환하는 액션
         */
        getDevice: () => {
            return get().currentDevice;
        },

        /**
         * 현재 접속 채널을 설정한다.
         * @param channel
         */
        setChannel: (channel: Channel) => {
            set((state) => {
                if (state.currentChannel !== channel) {
                    return { currentChannel: channel };
                }
                return state;
            });
        },

        /**
         * 현재 접속 채널정보를 반환한다.
         * @returns
         */
        getChannel: () => {
            return get().currentChannel;
        },

        /**
         * 현재 접속 채널을 설정한다.
         * @param system
         */
        setSystem: (system: Systems) => {
            set((state) => {
                if (state.currentSystem !== system) {
                    return { currentSystem: system };
                }
                return state;
            });
        },

        /**
         * 현재 접속 채널정보를 반환한다.
         * @returns
         */
        getSystem: () => {
            return get().currentSystem;
        },

        setConfig: (module, moduleConfig) => {
            set((state) => {
                return {
                    currentConfig: {
                        ...state.currentConfig,
                        [module]: moduleConfig,
                    },
                };
            });
        },

        getConfig: () => get().currentConfig,
    }));

const useConfigStore = (() => {
    if (_.isEmpty(storeInstance)) {
        storeInstance = createStore();
    }
    //console.log('useConfigStore - instanceId', storeInstance?.getState().instanceId);
    return createSelectorHooks(storeInstance!);
})();

export { useConfigStore };
